import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import UpdatePaymentDialogForm from "./UpdatePaymentDialogForm";
import { useUpdateTranscationMutation } from "src/services/TransactionsServices";
import { showToast } from "src/utils/showToaster";
import moment from "moment";

export type UpdatePaymentFormValuesType = {
  amount: any;
  receviedAmount: any;
  remark: string;
  dueDate: string;
};

type Props = {
  onClose: () => void;
  amount: any;
  setTotalAmount: any;
  setTransactionId: any;
  transactionId: string;
};

const UpdatePaymentDialogFormWrapper = ({
  onClose,
  amount,
  setTotalAmount,
  setTransactionId,
  transactionId,
}: Props) => {
  const [updateTransaction] = useUpdateTranscationMutation();

  // Form Initial Values
  const initialValues: UpdatePaymentFormValuesType = {
    amount: "",
    receviedAmount: amount || "",
    remark: "",
    dueDate: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    amount: string().required("Please enter amount").test(
      "receivedAmtTest",
      "amount must be more than 0",
      (value, context) => {
        return Number(value || 0) > 0;
      }
    ),
    dueDate: string().required("Please enter dueDate"),
    receviedAmount: string()
    .required("Please enter received amount"),
    remark: string().required("Please enter remark"),
  });

  // Handle Submit
  const handleSubmit = (
    values: UpdatePaymentFormValuesType,
    { setSubmitting, resetForm }: FormikHelpers<UpdatePaymentFormValuesType>
  ) => { 
    const toTakeAmount = amount - values?.amount
    const formattedValues = {
      amount: toTakeAmount,
      remark: values?.remark,
      previousAmount: amount,
      dueDate: moment(values?.dueDate).format("yyyy-MM-DD"),
    };
    updateTransaction({
        id:transactionId ,
        body:formattedValues
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          setTotalAmount('');
          setTransactionId('');
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <UpdatePaymentDialogForm
              totalamount={amount}
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default UpdatePaymentDialogFormWrapper;
